import { useGetPrograms } from '../api/useGetPrograms';
import { useGetMerchants } from '../api/useGetMerchants';
import { useGetUsers } from '../api/useGetUsers';
import { SummaryCard } from './SummaryCard';

export const HomeKpis = () => {
  const programs = useGetPrograms({ page: 0, limit: 1 });
  const merchants = useGetMerchants({ page: 0, limit: 1 });
  const guests = useGetUsers({ page: 0, limit: 1 });

  return (
    <div className="flex flex-wrap gap-4">
      <SummaryCard label="Total Programs" value={(programs.data?.payload?.total ?? 0).toLocaleString()} loading={programs.isLoading} />
      <SummaryCard label="Total Vendors" value={(merchants.data?.payload?.total ?? 0).toLocaleString()} loading={merchants.isLoading} />
      <SummaryCard label="Total Members" value={(guests.data?.payload?.total ?? 0).toLocaleString()} loading={guests.isLoading} />
    </div>
  );
};
